var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52204 5.05244C5.23361 4.76377 4.76564 4.76377 4.4772 5.05244C3.40626 6.12338 2.8799 7.61525 3.03286 9.1458C3.07103 9.52709 3.39224 9.81131 3.76736 9.81131C3.79201 9.81131 3.81685 9.81006 3.8415 9.8076C4.24767 9.76697 4.54396 9.40463 4.50333 8.99873C4.39447 7.91104 4.76591 6.85342 5.52204 6.09725C5.81072 5.80885 5.81072 5.34084 5.52204 5.05244Z",
    fill: "#B6B6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44828 0C3.78988 0 0 3.78988 0 8.44828C0 13.1067 3.78988 16.8966 8.44828 16.8966C13.1067 16.8966 16.8966 13.1067 16.8966 8.44828C16.8966 3.78988 13.1066 0 8.44828 0ZM8.44828 15.4187C4.60469 15.4187 1.47785 12.2919 1.47785 8.44828C1.47785 4.60469 4.60469 1.47785 8.44828 1.47785C12.2916 1.47785 15.4187 4.60469 15.4187 8.44828C15.4187 12.2919 12.2919 15.4187 8.44828 15.4187Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7837 19.2383L14.4142 13.8688C14.1255 13.5802 13.658 13.5802 13.3693 13.8688C13.0807 14.1573 13.0807 14.6253 13.3693 14.9137L18.7388 20.2831C18.8832 20.4275 19.0721 20.4996 19.2613 20.4996C19.4504 20.4996 19.6393 20.4275 19.7837 20.2831C20.0723 19.9947 20.0723 19.5267 19.7837 19.2383Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f87b53cbec5364139bba55360b7205fe.svg";
export { ForwardRef as ReactComponent };